import styled, { CSSProperties } from 'styled-components';

import { NorlysFont } from '~src/branding';
import { ResidenceEnergyLabel } from '~src/components/EnergyLabel';
import { Heading } from '~src/components/Typography';
import { Address, DeepPartial, Residence } from '~src/model';
import { formatAddress } from '~src/util';

type Position = 'absolute' | 'inline';

const Container = styled.div<{ position?: Position }>(({ position }) => ({
  ...(position === 'absolute'
    ? {
        position: 'absolute',
        top: '50%',
        transform: 'translate(0, -50%)',
        left: '315px',
      }
    : {}),
  display: 'flex',
  flexFlow: 'row nowrap',
  alignItems: 'center',
}));

type Props = {
  address?: Partial<Address>;
  residence?: DeepPartial<Residence>;
  position?: Position;
  style?: CSSProperties;
};

export const AddressStreamer = ({ address, residence, position = 'absolute', style }: Props) => (
  <Container position={position} style={style}>
    <ResidenceEnergyLabel style={{ marginRight: '8px' }} residence={residence} />
    <Heading level={2}>{address ? formatAddress(address) : ' '}</Heading>
  </Container>
);

export const AddressStreamerNorlys = ({ address, residence, position = 'absolute', style }: Props) => (
  <Container position={position} style={style}>
    <ResidenceEnergyLabel style={{ marginRight: '8px' }} residence={residence} />
    <Heading style={{ ...NorlysFont.style('heading', 18) }}>{address ? formatAddress(address) : ' '}</Heading>
  </Container>
);
